import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-zorin',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Zorin icon</title><path d="M4 18.944L5.995 22.4h12.01L20 18.944H4zM24 12l-2.013 3.488H9.216l12.771-6.976L24 12zM0 12l2.013-3.488h12.771L2.013 15.488 0 12zm4-6.944L5.995 1.6h12.01L20 5.056H4z"/></svg>`,
    styles: []
})
export class SimpleIconsZorinComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#0CC1F3';
    @Input() className: string = 'simple-icons-zorin'
    constructor() {}
    ngOnInit(): void {}
}
